import { render, staticRenderFns } from "./educationHistory.vue?vue&type=template&id=2de11bc2&scoped=true&"
import script from "./educationHistory.vue?vue&type=script&lang=js&"
export * from "./educationHistory.vue?vue&type=script&lang=js&"
import style0 from "./educationHistory.vue?vue&type=style&index=0&id=2de11bc2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de11bc2",
  null
  
)

export default component.exports